import {baseSplitApi} from '@/services';
import {Category} from '../types';

const categoryApi = baseSplitApi.injectEndpoints({
  endpoints: builder => ({
    getCategoryList: builder.query<Category[], Record<string, any>>({
      query: params => ({
        url: `/v1/category`,
        method: 'GET',
        params,
      }),
      providesTags: ['CategoryList'],
      serializeQueryArgs: ({endpointName}) => {
        return endpointName;
      },
      // merge: (currentCache, newItems, { arg }) => {
      //   if (arg.page == 1) {
      //     currentCache.length = 0;
      //     currentCache.push(...newItems);
      //   } else {
      //     currentCache.push(...newItems);
      //   }
      // },
      forceRefetch({currentArg, previousArg}) {
        return currentArg !== previousArg;
      },
      transformErrorResponse: (response: {status: string | number}) =>
        response.status,
      transformResponse: (response: {data: Category[]}, meta, arg) =>
        response.data,
    }),
    getCategory: builder.query<Category, string>({
      query: categoryId => ({
        url: `/v1/category/` + categoryId,
        method: 'GET',
      }),
      transformErrorResponse: (response: {status: string | number}) =>
        response.status,
      transformResponse: (response: {data: Category}, meta, arg) =>
        response.data,
    }),
  }),
});

export const {
  useGetCategoryListQuery,
  useLazyGetCategoryListQuery,
  useGetCategoryQuery,
} = categoryApi;
